<template >
  <div class="producth5" ref="producth5">
    <div class="jianjie">
      <div class="text">
        <div class="t1">让企业经营管理更高效 加速行业数字化升级</div>
        <div class="t2">—— ——丰派软件</div>
      </div>
    </div>
    <div class="company-culture">
      <div class="company-culture-item">
        <div class="title">公司介绍</div>
        <div class="tet">
          东莞市丰派软件科技有限公司是国内一家从事SaaS服务的企业，专注于为企业提供全渠道零售批发产品一站式数字化行业解决方案，助力企业在零售批发领域实现数字化转型升级，拥有多项核心自主知识产权。
        </div>
        <div class="img-box">
          <img src="@/assets/introduceContent1.png" class="img" alt="" />
        </div>
      </div>
      <div class="company-culture-item">
        <div class="title">公司文化</div>
        <div class="tet">公司价值观：利他、平等、个性、阳光</div>
        <div class="tet">公司愿景：成为商家服务领域最值得信赖的伙伴</div>
        <div class="tet">企业使命：在追求全体丰派人 物质与精神两方面幸福的同时，助力零售企业发展，推动零售行业进步，践行利他心，构造实现零售商业4.0</div>
        <div class="img-box">
          <img src="@/assets/introduceContent2.png" class="img" alt="" />
        </div>
      </div>
      <div class="company-culture-item company-culture-item1">
        <div class="title">业务体系</div>
        <div class="tet">
          产品体系丰富，覆盖收银软件、订货商城、零售端小程序智能AI、大数据BI等业务产品。涉及零售、餐饮、服装、母婴等50多个细分行业，十数年的行业互联网运营经营。服务于上千家企业级用户和数十万终端用户。
        </div>
        <div class="img-box">
          <img src="@/assets/introduceContent3.png" class="img" alt="" />
        </div>
      </div>
    </div>
    <div class="activity">
      <div class="text">团建活动</div>
      <div class="img-box">
        <div class="img-liet-box">
          <div class="img-item" v-for="item of activity" :key="item.url">
            <img :src="item.url" class="img" alt="" />
          </div>
        </div>
        <div class="img-liet-box">
          <div class="img-item" v-for="item of activity1" :key="item.url">
            <img :src="item.url" class="img" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="milestone">
      <div class="text">
        <div class="t1">我们的里程碑</div>
        <div class="t2">每一步都是一个脚印</div>
      </div>
      <div class="milestone-list" :class="isTrue ? 'active' : ''">
        <div
          class="milestone-item"
          v-for="(item, index) of milestoneList"
          :key="index"
        >
          <div class="milestone-left"></div>
          <div class="milestone-right" v-if="item.txt1">
            <div class="txt3">
              {{ item.txt1 }}
            </div>
          </div>
          <div class="milestone-right" v-else>
            <div class="txt1">{{ item.data }}</div>
            <div class="txt2">
              {{ item.txt }}
            </div>
          </div>
        </div>
      </div>
      <div class="btn" @click="isTrue = !isTrue">
        全部里程
        <img :src="isTrue ? top : bottom" class="img" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activity: [
        {
          url: require("@/assets/tj2.png"),
        },
        {
          url: require("@/assets/tj1.png"),
        },
        {
          url: require("@/assets/tj3.png"),
        },
      ],
      activity1: [
        {
          url: require("@/assets/tj4.png"),
        },
        {
          url: require("@/assets/tj5.png"),
        },
        {
          url: require("@/assets/tj6.png"),
        },
      ],
      milestoneList: [
        {
          txt1: "正在努力开创未来...",
        },
        {
          data: "2022-11",
          txt: "推出行业首款微商城，可实现一分钟快速上线，商家售货就这么简单",
        },
        {
          data: "2022-08",
          txt: "推出自助收银以及手机收银 让收银变得更简单   ",
        },
        {
          data: "2022-06",
          txt: "上线客户突破10000+                      收银打通第三方外卖平台，为商家带去更多销售渠道 ",
        },
        {
          data: "2021-06",
          txt: "推出收银Windows版本，小程序线上商城，市场占有率突破性提升",
        },
        {
          data: "2021-03",
          txt: "收银软件Android发布，获得市场强烈反响",
        },
        {
          data: "2021-01",
          txt: "零售商城线上企业级客户数破千，终端用户突破2w+",
        },
        {
          data: "2020-07",
          txt: "零售商城微信小程序发布",
        },
        {
          data: "2020-05",
          txt: "社区团购版本上线，协助企业完成日超10w+销售额的突破",
        },
        {
          data: "2020-03",
          txt: "订货商城整体销售额破亿，瞅准零售市场，开始零售商城研发",
        },
        {
          data: "2019-10",
          txt: "订货商城正式上线，获得智百威首轮投资",
        },
        {
          data: "2019-07",
          txt: "订货商城首次开放内测名额，邀请多家本地龙头企业参与体验",
        },
        {
          data: "2019-03",
          txt: "成立研发团队，多名资深开发设计人员加入，初步团队组建完成",
        },
        {
          data: "2018-06",
          txt: "订货商城整体方案设计并确定企业发展方向",
        },
        {
          data: "2018-03",
          txt: "发现市场需求，展开为期数月4万终端用户的市场调研",
        },
        {
          data: "2017-12",
          txt: "累计服务终端用户数突破1w+",
        },
        {
          data: "2017-09",
          txt: "公司发展客户数突破1000+",
        },
        {
          data: "2017-05",
          txt: "公司成立，进军零售行业",
        },
      ],
      top: require("@/assets/shang.png"),
      bottom: require("@/assets/xia.png"),
      isTrue: true,
    };
  },
  activated() {
    this.$refs.producth5.scrollIntoView();
  },
};
</script>

<style lang="less" scoped>
.producth5 {
  width: 750px;
  .jianjie {
    width: 750px;
    height: 560px;
    background: url("~@/assets/jianjie.png") no-repeat;
    background-size: 100% 100%;
    padding: 0 48px;
    .text {
      padding-top: 160px;
      .t1 {
        font-weight: 700;
        font-size: 64px;
        line-height: 100px;
        color: #336fff;
      }
      .t2 {
        margin-top: 17px;
        text-align: right;
        font-size: 36px;
        font-weight: 700;
        line-height: 80px;
      }
    }
  }
  .company-culture {
    padding: 64px 32px;
    background: #f5f7fa;
    .company-culture-item {
      margin-bottom: 40px;
      width: 686px;
      height: 806px;
      background: url("~@/assets/gsjs.png") no-repeat;
      background-size: 100% 100%;
      padding: 50px 32px;
      .title {
        font-weight: 500;
        font-size: 40px;
        line-height: 56px;
        color: #fff;
      }
      .tet {
        font-size: 28px;
        line-height: 40px;
        color: #fff;
      }
      .img-box {
        margin-top: 30px;
        width: 622px;
        height: 400px;
        .img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .company-culture-item1 {
      margin-bottom: 0;
    }
  }
  .activity {
    width: 750px;
    padding: 64px 40px;
    .text {
      text-align: center;
      font-size: 40px;
      line-height: 48px;
      color: #292929;
      font-weight: 500;
    }
    .img-box {
      width: 670px;
      overflow: hidden;
      overflow-x: auto;
      .img-liet-box {
        width: 1232px;
        height: 216px;
        margin-top: 40px;
        display: flex;
        align-items: center;
        overflow-x: auto;
        .img-item {
          width: 384px;
          height: 216px;
          margin-right: 40px;
          .img {
            width: 100%;
            height: 100%;
          }
        }
        .img-item:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .milestone {
    padding: 64px 0;
    background: #f5f7fa;
    .text {
      text-align: center;
      .t1 {
        font-size: 40px;
        font-weight: 500;
        line-height: 48px;
        color: #1f2329;
      }
      .t2 {
        margin-top: 20px;
        font-size: 28px;
        line-height: 40px;
        color: #51565d;
      }
    }
    .milestone-list {
      padding: 0 40px;
      margin-top: 40px;
      &.active {
        height: 696px;
        overflow: hidden;
      }
      .milestone-item {
        display: flex;
        .milestone-left {
          width: 1px;
          background: #c5c5c5;
          position: relative;
        }
        .milestone-left:after {
          position: absolute;
          top: 8px;
          left: -12px;
          content: "";
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: #ffffff;
          border: 2px solid #336fff;
        }
        .milestone-right {
          margin-left: 26px;
          .txt3 {
            font-weight: 500;
            font-size: 32px;
            line-height: 40px;
            color: #51565d;
            margin-bottom: 32px;
          }
          .txt1 {
            font-weight: 500;
            font-size: 32px;
            line-height: 40px;
            color: #336fff;
          }
          .txt2 {
            font-size: 26px;
            line-height: 36px;
            color: #51565d;
            padding: 16px 0 32px;
          }
        }
      }
    }
    .btn {
      margin-top: 40px;
      width: 670px;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
      line-height: 40px;
      color: #336fff;
      .img {
        width: 32px;
        height: 32px;
        margin-left: 8px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/h5/productH5.vue